import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpResponseDto, InventoryControllerService, ProductDto, QuotationLineDto} from "../../../../../@api";
import {RecipientDto} from "../../recipient-dto";

@Component({
    selector: 'secure-product-list-overlay',
    templateUrl: './product-list-overlay.component.html',
    styleUrls: ['./product-list-overlay.component.scss']
})
export class ProductListOverlayComponent implements OnInit {

    @Input() quotationLine!: QuotationLineDto;
    @Input() show: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() product: EventEmitter<ProductDto> = new EventEmitter<ProductDto>();

    isVisible: boolean = false;
    products!: ProductDto[];
    cols: any[] = [];

    constructor(private inventoryService: InventoryControllerService) {
    }

    ngOnInit(): void {
        this.show.subscribe((data: boolean) => this.onShow(data));
    }

    onShow(indicator: boolean): void {
        this.isVisible = indicator;

        if (this.isVisible) {
            if (!this.products) {
                this.inventoryService.findAllProducts().subscribe((response: HttpResponseDto): void => {
                    this.products = JSON.parse(response.data);
                    (this.products || []).forEach((p: ProductDto): void => {
                        const brand: string = p.brand;
                        const name: string = p.name;
                        const subCategory: string = p.subCategory;
                        const searchString: string = brand + ',' + name + ',' + subCategory;
                        console.log('searchString: ' + searchString);

                        p['searchString'] = searchString;
                    });
                }, error => {
                    console.log(JSON.stringify(error));
                });
            }
        }
    }

    cancel(): void {
        this.isVisible = false;
    }

    addToQuote(product: ProductDto): void {
        this.product.emit(product);
        this.isVisible = false;
    }
}